"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERSON_ORIGIN_CAT = void 0;
var PERSON_ORIGIN_CAT;
(function (PERSON_ORIGIN_CAT) {
    PERSON_ORIGIN_CAT[PERSON_ORIGIN_CAT["SIGNUP"] = 1] = "SIGNUP";
    PERSON_ORIGIN_CAT[PERSON_ORIGIN_CAT["EVENTOS"] = 2] = "EVENTOS";
    PERSON_ORIGIN_CAT[PERSON_ORIGIN_CAT["PAPELETAS"] = 3] = "PAPELETAS";
    PERSON_ORIGIN_CAT[PERSON_ORIGIN_CAT["CRM"] = 4] = "CRM";
    PERSON_ORIGIN_CAT[PERSON_ORIGIN_CAT["CENTRAL_TEST"] = 5] = "CENTRAL_TEST";
    PERSON_ORIGIN_CAT[PERSON_ORIGIN_CAT["BANNER"] = 6] = "BANNER";
    PERSON_ORIGIN_CAT[PERSON_ORIGIN_CAT["MEMBRESIAS"] = 7] = "MEMBRESIAS";
    PERSON_ORIGIN_CAT[PERSON_ORIGIN_CAT["CHECKOUT"] = 8] = "CHECKOUT";
    PERSON_ORIGIN_CAT[PERSON_ORIGIN_CAT["ADMISION_BANNER"] = 9] = "ADMISION_BANNER";
    PERSON_ORIGIN_CAT[PERSON_ORIGIN_CAT["PAYMENT_LINK"] = 12] = "PAYMENT_LINK";
})(PERSON_ORIGIN_CAT = exports.PERSON_ORIGIN_CAT || (exports.PERSON_ORIGIN_CAT = {}));
